/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var BookOpen = createReactComponent("book-open", "BookOpen", [["path", { "d": "M12 9.8V20m0-10.2c0-1.704.107-3.584-1.638-4.473C9.72 5 8.88 5 7.2 5H4.6C3.364 5 3 5.437 3 6.6v8.8c0 .568-.036 1.195.546 1.491.214.109.493.109 1.052.109H7.43c2.377 0 3.26 1.036 4.569 3m0-10.2c0-1.704-.108-3.584 1.638-4.473C14.279 5 15.12 5 16.8 5h2.6c1.235 0 1.6.436 1.6 1.6v8.8c0 .567.035 1.195-.546 1.491-.213.109-.493.109-1.052.109h-2.833c-2.377 0-3.26 1.036-4.57 3", "key": "svg-0" }]]);

export { BookOpen as default };
//# sourceMappingURL=BookOpen.js.map
